import {
  CreateItemRequest,
  ItemBestSellerModel,
  ItemModel,
  ToppingModel,
} from "../model/ProductItemModel";
import { ApiClient } from "../api/ApiClient";
const BASE_URL = "/api/items";
class ItemServiceClass {
  getAllItem() {
    return ApiClient.get<ItemModel[]>(BASE_URL + "/all");
  }

  getAllTopping() {
    return ApiClient.get<ToppingModel[]>(BASE_URL + "/toppings/all");
  }

  getItemsBestSeller() {
    return ApiClient.get<ItemBestSellerModel[]>(BASE_URL + `/best-seller`);
  }

  createNewTopping(request: Omit<ToppingModel, "id">) {
    return ApiClient.post<ToppingModel>(BASE_URL + "/toppings/add", request);
  }

  updateTopping(request: ToppingModel) {
    return ApiClient.put<ToppingModel>(BASE_URL + `/toppings/${request.id}/update`, request);
  }

  deleteTopping(toppingId: number) {
    return ApiClient.delete(BASE_URL + `/toppings/delete/${toppingId}`);
  }

  createNewItem(request: CreateItemRequest, imageFile?: File) {
    const formData = new FormData();
    if (imageFile) {
      formData.append("files", imageFile, imageFile.name);
    }
    formData.append("request", JSON.stringify(request));
    return ApiClient.post<ItemModel>(BASE_URL + "/create", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  updateItem(request: CreateItemRequest & { id: number; imageFile?: File }) {
    const formData = new FormData();
    if (request?.imageFile) {
      formData.append("files", request.imageFile, request.imageFile.name);
    }
    const { id, imageFile, ...bodyRequest } = request;
    formData.append("request", JSON.stringify(bodyRequest));
    return ApiClient.put<ItemModel>(BASE_URL + `/update/${request.id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
  deleteItem(itemId: number) {
    return ApiClient.delete(BASE_URL + `/delete/${itemId}`);
  }
}

export const ItemService = new ItemServiceClass();
